import { RiArrowDownSLine, RiArrowUpSLine } from "@remixicon/react";
import classNames from "classnames";
import React, {
    ReactElement, ReactNode,
    useEffect,
    useRef,
    useState,
} from "react";
import Button from "../theme/button/Button";
import Styles from "./AdvancedSection.module.scss";

export default function ExpandableText({
    children, onExpanded, onCollapsed, className, defaultExpanded,
}: {
    children: ReactNode;
    onExpanded?: () => void;
    onCollapsed?: () => void;
    className?: string
    defaultExpanded?: boolean;

}): ReactElement {
    const [isExpanded, setExpanded] = useState(defaultExpanded);
    const [canExpand, setCanExpand] = useState(true);

    const elementRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        function handleResize() {
            if (elementRef && elementRef.current) {
                setCanExpand(
                    elementRef.current.scrollHeight > elementRef.current.clientHeight,
                );
            }
        }

        handleResize();
        window.addEventListener("resize", handleResize);

        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const toggle = () => {
        setExpanded(current => !current);
        if (isExpanded) {
            onCollapsed?.();
        } else {
            onExpanded?.();
        }
    };
    return (
        <div>
            <div
                data-clamp={3}
                className={classNames(
                    Styles["expandable-text"],
                    !isExpanded ? Styles["expandable-text-collapsed"] : "",
                    className,
                )}
                ref={elementRef}
            >
                {children}
            </div>
            {canExpand && (
                <div>
                    <Button
                        onClick={toggle}
                        variant="none"
                        className={Styles["expandable-text-button"]}
                        postfixIcon={isExpanded
                            ? <RiArrowUpSLine />
                            : <RiArrowDownSLine />}
                    >
                        {isExpanded ? "Show Less" : "Show More"}
                    </Button>
                </div>
            )}

        </div>

    );
}

ExpandableText.defaultProps = {
    defaultExpanded: false,
    onExpanded: undefined,
    onCollapsed: undefined,
    className: undefined,
};
